import api from "./axios";

class ServiceCheck {
  async save(check) {
    const { data } = await api.post("/checks", check);
    return data.id;
  }

  async update(check) {
    await api.put(`/checks/${check.id}`, check);
  }

  async delete(id) {
    await api.delete(`/checks/${id}`);
  }

  async findById(id) {
    const { data } = await api.get(`/checks/${id}`);
    return data;
  }

  async search(filters) {
    const { data } = await api.get("/checks", { params: filters });
    return data;
  }

}

export default new ServiceCheck();
